// src/utils/storage.js

const STORAGE_KEYS = {
  USER_AUTH:       "mmh_user_auth",
  USER_PHONE:      "mmh_user_phone",
  REDIRECT_URL:    "mmh_redirect_url",
  ADMIN_TOKEN:     "mmh_admin_token",
  UPDATED_BY:      "mmh_updated_by",
  CUSTOMER_TOKEN:  "mmh_customer_token",  // ← Customer OTP login token
  USER_ISD_CODE:   "mmh_user_isd_code",   // ← Customer ka ISD code (token-expiry match ke liye)
};

const saveToStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error("Error saving to storage:", error);
    return false;
  }
};

const getFromStorage = (key) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error getting from storage:", error);
    return null;
  }
};

const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};

// ─── Normal user auth (OTP based) ────────────────────────────────────────────
export const isAuthenticated = () => {
  const auth = getFromStorage(STORAGE_KEYS.USER_AUTH);
  return auth && auth.isAuthenticated === true;
};

export const saveAuth = (phone) => {
  return saveToStorage(STORAGE_KEYS.USER_AUTH, {
    isAuthenticated: true,
    phone,
    timestamp: new Date().toISOString(),
  });
};

export const clearAuth = () => {
  removeFromStorage(STORAGE_KEYS.USER_AUTH);
  removeFromStorage(STORAGE_KEYS.USER_PHONE);
  removeFromStorage(STORAGE_KEYS.CUSTOMER_TOKEN);
};

// ─── Customer token (OTP verify ke baad milta hai) ───────────────────────────
export const saveCustomerToken = (token) =>
  saveToStorage(STORAGE_KEYS.CUSTOMER_TOKEN, token);

export const getCustomerToken = () =>
  getFromStorage(STORAGE_KEYS.CUSTOMER_TOKEN);

export const clearCustomerToken = () =>
  removeFromStorage(STORAGE_KEYS.CUSTOMER_TOKEN);

// ─── Customer ISD code (contact match ke liye — token expiry check) ─────────
export const saveUserIsdCode = (isdCode) =>
  saveToStorage(STORAGE_KEYS.USER_ISD_CODE, isdCode);

export const getUserIsdCode = () =>
  getFromStorage(STORAGE_KEYS.USER_ISD_CODE);

export const clearUserIsdCode = () =>
  removeFromStorage(STORAGE_KEYS.USER_ISD_CODE);

// ─── Customer session clear (expired/mismatched token pe use hoga) ──────────
// NOTE: ye clearAuth se alag hai — sirf customer token-expiry flow ke liye,
// baaki kahin ka existing clearAuth call untouched rahega.
export const clearCustomerSession = () => {
  removeFromStorage(STORAGE_KEYS.CUSTOMER_TOKEN);
  removeFromStorage(STORAGE_KEYS.USER_ISD_CODE);
};

// ─── Admin token auth (URL token based) ──────────────────────────────────────
export const saveAdminToken = (token, updatedBy) => {
  saveToStorage(STORAGE_KEYS.ADMIN_TOKEN, token);
  saveToStorage(STORAGE_KEYS.UPDATED_BY, updatedBy || "user");
};

export const getAdminToken = () => getFromStorage(STORAGE_KEYS.ADMIN_TOKEN);

export const getUpdatedBy = () =>
  getFromStorage(STORAGE_KEYS.UPDATED_BY) || "user";

export const isTokenAuthenticated = () => {
  const token = getFromStorage(STORAGE_KEYS.ADMIN_TOKEN);
  return !!(token && token.length > 0);
};

export const clearAdminToken = () => {
  removeFromStorage(STORAGE_KEYS.ADMIN_TOKEN);
  removeFromStorage(STORAGE_KEYS.UPDATED_BY);
};

// ─── Koi bhi auth valid ho (OTP ya token) ────────────────────────────────────
export const isAnyAuthenticated = () => isAuthenticated() || isTokenAuthenticated();

// ─── Phone ───────────────────────────────────────────────────────────────────
export const saveUserPhone = (phone) => saveToStorage(STORAGE_KEYS.USER_PHONE, phone);
export const getUserPhone  = ()      => getFromStorage(STORAGE_KEYS.USER_PHONE);

// ─── Redirect URL ─────────────────────────────────────────────────────────────
export const saveRedirectUrl  = (url) => saveToStorage(STORAGE_KEYS.REDIRECT_URL, url);
export const getRedirectUrl   = ()    => getFromStorage(STORAGE_KEYS.REDIRECT_URL);
export const clearRedirectUrl = ()    => removeFromStorage(STORAGE_KEYS.REDIRECT_URL);

export default STORAGE_KEYS;